import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";

const pillars = [
  { icon: "🎬", en: "Localized Live-Action", zh: "本地化实拍内容", desc: "Authentic local stories, real actors, deep cultural resonance across SEA." },
  { icon: "🤖", en: "AI-Enhanced Pipeline", zh: "AI赋能生产流程", desc: "Script ideation, storyboarding, editing and analytics — powered by AI." },
  { icon: "📡", en: "Multi-Platform Distribution", zh: "多平台内容分发", desc: "TikTok · YouTube · Proprietary Platform — maximizing reach & user acquisition." },
  { icon: "💎", en: "IP Development", zh: "IP开发与长期变现", desc: "Transforming hit content into long-term intellectual property assets." },
];

const About = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setVisible(true); }, { threshold: 0.2 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section id="about" ref={ref} style={{ padding: "100px 40px" }}>
      <div style={{ maxWidth: 1100, margin: "0 auto" }}>
        <motion.div initial={{ opacity: 0, y: 24 }} animate={visible ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.7 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20 }}>
            <div style={{ width: 36, height: 2, background: "#FF1C35" }} />
            <span style={{ color: "#FF1C35", fontSize: 12, fontWeight: 700, letterSpacing: 3 }}>COMPANY OVERVIEW · 公司概览</span>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 60, alignItems: "start" }}
            className="about-grid">
            <div>
              <h2 style={{ fontSize: "clamp(32px, 5vw, 52px)", fontWeight: 900, lineHeight: 1.1, margin: "0 0 24px" }}>
                Building a Scalable<br />
                <span style={{ color: "#FF1C35" }}>Content System</span><br />
                <span style={{ color: "rgba(255,255,255,0.3)", fontSize: "0.6em", fontWeight: 400 }}>打造可规模化的内容体系</span>
              </h2>
              <p style={{ fontSize: 16, color: "rgba(255,255,255,0.6)", lineHeight: 1.8, marginBottom: 16 }}>
                MIRE Media is an AI-driven pan-entertainment platform headquartered in Kuala Lumpur, focused on Southeast Asia's rapidly growing digital content market.
              </p>
              <p style={{ fontSize: 14, color: "rgba(255,255,255,0.35)", lineHeight: 1.8, marginBottom: 32 }}>
                通过将实拍内容与AI效率结合，MIRE将内容生产转变为可复制、可规模化的体系，深耕马来语、英语、中文三语内容创作。
              </p>
              <div style={{ display: "flex", gap: 24, flexWrap: "wrap" }}>
                {["Kuala Lumpur HQ", "London · Singapore · New York", "Malay · English · Chinese"].map(t => (
                  <span key={t} style={{
                    padding: "6px 14px", borderRadius: 999,
                    border: "1px solid rgba(255,28,53,0.3)",
                    color: "rgba(255,255,255,0.6)", fontSize: 12, fontWeight: 500,
                  }}>{t}</span>
                ))}
              </div>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
              {pillars.map((p, i) => (
                <motion.div key={p.en}
                  initial={{ opacity: 0, y: 20 }} animate={visible ? { opacity: 1, y: 0 } : {}}
                  transition={{ delay: 0.2 + i * 0.1, duration: 0.6 }}
                  style={{
                    padding: "24px 20px", borderRadius: 14,
                    background: "rgba(255,255,255,0.03)",
                    border: "1px solid rgba(255,255,255,0.07)",
                    transition: "border-color 0.3s",
                  }}
                  whileHover={{ borderColor: "rgba(255,28,53,0.4)" } as never}
                >
                  <div style={{ fontSize: 28, marginBottom: 10 }}>{p.icon}</div>
                  <div style={{ fontSize: 13, fontWeight: 700, color: "#fff", marginBottom: 4 }}>{p.en}</div>
                  <div style={{ fontSize: 11, color: "rgba(255,255,255,0.3)", marginBottom: 8 }}>{p.zh}</div>
                  <div style={{ fontSize: 12, color: "rgba(255,255,255,0.5)", lineHeight: 1.6 }}>{p.desc}</div>
                </motion.div>
              ))}
            </div>
          </div>
        </motion.div>
      </div>
      <style>{`
        @media (max-width: 768px) { .about-grid { grid-template-columns: 1fr !important; gap: 40px !important; } }
      `}</style>
    </section>
  );
};

export default About;
